module.exports = __webpack_public_path__ + "img/pic09.0a4add36.jpg";